import Sun from "../../../core/assets/oot/gshd/suns-song_32x32.png";
import Song from "../../../core/items/Song";
import StaticItem from "../../../core/items/StaticItem";
import OotItem from "../items/OotItem";
import { SimpleItemProps } from "../items/SimpleItemProps";
interface SunSongProps {
    cup: boolean,
    cdown: boolean,
    cright: boolean
    display: "vertical" | "horizontal" | "double line horizontal"
}

let id = "Oot_SunSong"

const SunSong = (props: SunSongProps) => {

    let songIsPlayable = props.cup && props.cright && props.cdown;
    


    return <OotItem id={id}>
        {({ updateOotItem, item }) => {

            return <Song id={id} image={Sun} title="Sun Song"  isLocked={!songIsPlayable} updateItem={updateOotItem} item={item} display={props.display} />
        }}</OotItem>
}

export default SunSong

export const SimpleSunSong = (props: SimpleItemProps) => {


    return <StaticItem
        image={Sun}
        onClick={props.onClick}
        name={id}
    />


}